var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduce_page"},_vm._l((31),function(v){return _c('img',{key:v,staticClass:"introduce_img",attrs:{"src":("http://app.qcql.cn/img/productConfigImg/产品配置表_" + (v < 10 ? '0'+v : v) + ".jpg")}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1942f136","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productConfig.vue
// module id = null
// module chunks = 